import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Component
import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { MyGuard } from './custom-guard';

function loadModuleBasedOnCondition(): Promise<any> {
  // Your condition logic goes here
  const condition = true;

  // Return the promise to load the module dynamically
  if (condition) {
    return import('./pages/pages.module').then(m => m.PagesModule);
  } else {
    return Promise.reject('Error: condition failed');
  }
}

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('../app/landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'app',
    component: LayoutComponent,
    loadChildren: loadModuleBasedOnCondition,
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: '**',
    redirectTo: '/app/facilities',
    pathMatch: 'full'
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
